export type ChartSize = "sm" | "md" | "lg";

export const SMALL_CHART_HEIGHT = 25;
export const MEDIUM_CHART_HEIGHT = 55;
export const LARGE_CHART_HEIGHT = 220;

export const getChartSize = (size: ChartSize | undefined): number | undefined => {
	switch (size) {
		case "sm":
			return SMALL_CHART_HEIGHT;
		case "md":
			return MEDIUM_CHART_HEIGHT;
		case "lg":
			return LARGE_CHART_HEIGHT;
		default:
			return undefined;
	}
};
